import React from "react";
import "./style.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function BaseCard({ children, className }: Props) {
  const cls = ["base-card"];
  if (className) cls.push(className);
  return <div className={cls.join(" ")}>{children}</div>;
}
